import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

export const getEditorSettings = (editor: monaco.editor.IStandaloneCodeEditor): monaco.editor.IStandaloneCodeEditor => {
    // Disable `F1` command palette
    editor.addCommand(monaco.KeyCode.F1, () => false);
    return editor;
}

export const getDiffEditorSettings = (editor: monaco.editor.IStandaloneDiffEditor): monaco.editor.IStandaloneDiffEditor => {
    // Disable `F1` command palette
    editor.addCommand(monaco.KeyCode.F1, () => false);
    return editor;
}
